import { customizeDonorSite } from '../utils/fetch';
import IGlobalConfig from '../types/IGlobalConfig';

export async function triggerCharityDeployment(
  charityId: string,
  customizationData: Record<string, any>,
  config: IGlobalConfig,
  serviceAccessToken: string,
  wlwSubdomain?: string
): Promise<void> {
  try {
    await customizeDonorSite(
      config?.adminServiceUrl,
      charityId,
      serviceAccessToken,
      customizationData,
      wlwSubdomain
    );
    
  } catch (error) {
    console.error('Failed to trigger deployment:', error);
    throw new Error(
      `Failed to trigger deployment: ${error instanceof Error ? error.message : 'Unknown error'}`
    );
  }
}